module.exports = __webpack_public_path__ + "img/internet11.ca77fc3f.png";